import { ajax } from "@/plugins/api";

const fetch = (url, method = "get", data = null) => {
    return ajax[method](`tg-interface/admin/finances/` + url, data).then(data => data.data);
};
export const api = {
    getMainData: () => fetch(`main`),
    getAdminTransactions: page => fetch(`main/transactions?page=${page}`),
    getUsersAccounts: () => fetch(`accounts`),
    getUsersAccountTransactions: accountId => fetch(`account/${accountId}/transactions`),

    getUsersPayouts: () => fetch(`payouts`),
    getPayout: payoutId => fetch(`payout/${payoutId}`),
    setPaidStatus: payoutId => fetch(`payout/${payoutId}/paid`, "post"),
    setDeclinedStatus: (payoutId, data) => fetch(`payout/${payoutId}/decline`, "post", data)
    // getAccount: id => fetch(`admin/account/${id}`),
    //
    // updateAccount: (id, data) => fetch(`admin/account/${id}`, "put", data),
    // approveAccount: id => fetch(`admin/account/${id}/approve`, "post"),
    // declineAccount: (id, data) => fetch(`admin/account/${id}/decline`, "post", data),
    //
    // getServerList: () => fetch("admin/servers"),
    //
    // getOrder: id => fetch(`moderator/item/${id}/?include=stat`),
    // updateApplication: (id, data) => fetch(`moderator/user/item/${id}`, "put", data),
    // setApplicationStatus: (id, status, reason) => {
    //     return fetch(`moderator/item/${id}/${status}?include=history`, "patch", { reason });
    // },
    // getLicenseKey: id => fetch(`moderator/item/${id}/license`, "post"),
    // regenerateLicenseKey: id => fetch(`moderator/item/${id}/license?regenerate`, "post"),
    // disableLicense: id => fetch(`moderator/item/${id}/disable`, "post"),
    // updateSettings: (id, settings) => fetch(`moderator/user/item/${id}/settings/`, "patch", settings)
};
